import { Component, OnInit, OnDestroy, Input, ChangeDetectorRef, NgZone, ViewEncapsulation } from '@angular/core';
import { padStart } from 'lodash';

@Component({
  selector: 'app-countdown-timer',
  templateUrl: './countdown-timer.component.html',
  styleUrls: ['./countdown-timer.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class CountdownTimerComponent implements OnInit, OnDestroy {
  private _intervalHandle;

  constructor(private _changeDetectorRef: ChangeDetectorRef, private _ngZone: NgZone) {
  }

  @Input()
  public countUntilTime: number;

  public minutes: string;

  public seconds: string;

  ngOnInit(): void {
    this.onInterval(new Date());

    // Run the timer outside of Angular only for testability.
    // Without this Protractor continuously waits for the timer to complete, and timeout occurs in the E2E tests.
    // Read more: https://github.com/angular/protractor/issues/3349.
    this._ngZone.runOutsideAngular(() => {
      this._intervalHandle = setInterval(() => {
        this.onInterval(new Date());

        this._changeDetectorRef.detectChanges();
      }, 1000);
    });
  }

  ngOnDestroy(): void {
    this.stopCounter();
  }

  stopCounter() {
    clearInterval(this._intervalHandle);
  }

  public onInterval(currentTime: Date): void {
    const nowMilliseconds = currentTime.getTime();

    let remainingTimeInMilliseconds = this.countUntilTime - nowMilliseconds;

    if (remainingTimeInMilliseconds <= 0) {
      this.stopCounter();

      remainingTimeInMilliseconds = 0;
    }

    const remainingTimeInMinutes = remainingTimeInMilliseconds / 1000 / 60;

    this.minutes = Math.floor(remainingTimeInMinutes).toString();
    this.seconds = padStart(Math.floor(((remainingTimeInMinutes % 1) * 60)).toString(), 2, '0');
  }
}
